module.exports = __webpack_public_path__ + "static/media/siddharth-amaravati-trip-06.3fe58fbc.png";